@let loading = loading$ | async;
@let error = error$ | async;
@let passwordVisible = passwordVisible$ | async;
@let repeatVisible = repeatVisible$ | async;
@let password = form.controls.password;

<header class="rms-dialog-header">
  <div class="rms-dialog-header-content">
    <h3 class="rms-dialog-header-content-title">
      {{ "partners.users.password.title" | translate: { name: data.user.full_name } }}
    </h3>
  </div>
  <rms-close-button mat-dialog-close />
</header>

<div class="flex flex-col gap-2">
  @if (error) {
    <rms-toast
      icon="remix:System/error-warning-fill"
      color="ochraceus"
      [message]="error" />
  }

  <form
    class="flex flex-col gap-4"
    [formGroup]="form"
    (ngSubmit)="submit()">
    <div class="form-control">
      <label for="password">{{ "partners.users.password.new" | translate }}</label>
      <mat-form-field subscriptSizing="dynamic">
        <input
          id="password"
          class="[&::-ms-reveal]:hidden [&::-ms-clear]:hidden"
          matInput
          [type]="passwordVisible ? 'text' : 'password'"
          formControlName="password"
          autocomplete="new-password"
          rmsControlError />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="
            (passwordVisible ? 'auth.controls.hide-password' : 'auth.controls.show-password') | translate
          "
          (click)="passwordVisible$.next(!passwordVisible)">
          <mat-icon [svgIcon]="passwordVisible ? 'remix:System/eye-line' : 'remix:System/eye-off-line'" />
        </button>
        @if (!(password.invalid && password.touched)) {
          <mat-hint>{{ "partners.users.password.hint" | translate }}</mat-hint>
        }
      </mat-form-field>
    </div>

    <div class="form-control">
      <label for="repeat">{{ "auth.controls.repeat-password.label" | translate }}</label>
      <mat-form-field subscriptSizing="dynamic">
        <input
          id="repeat"
          class="[&::-ms-reveal]:hidden [&::-ms-clear]:hidden"
          matInput
          [type]="repeatVisible ? 'text' : 'password'"
          formControlName="repeat"
          autocomplete="new-password"
          rmsControlError />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="
            (repeatVisible ? 'auth.controls.hide-password' : 'auth.controls.show-password') | translate
          "
          (click)="repeatVisible$.next(!repeatVisible)">
          <mat-icon [svgIcon]="repeatVisible ? 'remix:System/eye-line' : 'remix:System/eye-off-line'" />
        </button>
      </mat-form-field>
    </div>

    <div class="rms-dialog-actions">
      <button
        type="button"
        class="rms-dialog-actions-button"
        mat-button
        mat-dialog-close>
        {{ "libs.common.cancel" | translate }}
      </button>
      <button
        type="submit"
        color="primary"
        class="rms-dialog-actions-button"
        mat-raised-button
        [disabled]="form.invalid || loading">
        @if (loading) {
          <mat-progress-spinner
            class="stroke-white"
            mode="indeterminate"
            [diameter]="30" />
        } @else {
          {{ "partners.users.password.submit" | translate }}
        }
      </button>
    </div>
  </form>
</div>
